import { usePortalApi } from "../api-access/use-portal-api";

export function useCompletionConfigurations() {
  return usePortalApi(
    client => client.getConfigurations(),
    ["getConfigurations"]
  );
}
